var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:[{active: _vm.isTabActive}, _vm.$css(_vm.styles.sidebar), _vm.$css(_vm.styles.sidebarActive)],attrs:{"id":"sidebar"}},[_c('SourcesWidget'),_c('ThemeSelector'),_c('PaletteColors'),_c('FontSelector'),_c('AdvancedParams')],1)}
var staticRenderFns = []

export { render, staticRenderFns }